import React from 'react'
import { useLocation } from 'react-router-dom';
import { IoReturnUpBack } from "react-icons/io5";

const BackButton = () => {
    const location = useLocation();

    // Function to go back
    const goBack = () => {
      // Navigating back
      location.state ? window.history.go(-1) : window.history.back();
    };
  return (
    <div>
       <button
                type="button"
                onClick={goBack}
                className="flex items-center gap-2 bg-red-500  rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
              >
                <span> <IoReturnUpBack /> </span>
                <span>Back</span>
              </button>
    </div>
  )
}

export default BackButton
